// salesforceScreeningQuestions.js
//
// Now a thin wrapper around the Saaeda backend proxy. The backend handles the
// fallback / describe logic — the browser no longer holds an access token.

import { fetchScreeningQuestions } from "../../../Auth/saaedaApi";

/**
 * Fetch screening questions for a vacancy.
 * Signature kept backwards-compatible (`accessToken` and `opts` are ignored).
 */
export async function queryScreeningQuestions(vacancyId, _accessTokenIgnored, _optsIgnored) {
  const records = await fetchScreeningQuestions(vacancyId);
  return records.map((r) => ({
    Id: r.Id,
    Title__c: r.Title__c ?? null,
    Type__c: r.Type__c ?? null,
    Required__c: r.Required__c ?? false,
    Options__c: r.Options__c ?? null,
  }));
}
